import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import CampaignGroup from "client_config/ppc_config/CampaignGroup";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import ConfigureCampaignGroup from "./ConfigureCampaignGroup";
import jsDig from "utils/jsDig";

export default function CampaignGroups(props) {
  const platform = props.platformType.toLowerCase();
  const campaignGroupsInitial =
    props[`${platform}_section`].campaign_groups && props[`${platform}_section`].campaign_groups.length > 0 ? props[`${platform}_section`].campaign_groups : [];
  // Need to grab conversion actions for preexisting campaign groups
  campaignGroupsInitial.forEach((element) => {
    if (!element["conversion_actions"]) {
      element["conversion_actions"] = props.conversion_actions.filter((el) => el.section_id == element.id);
    }
  });
  const [campaignGroups, setCampaignGroups] = useState(campaignGroupsInitial);
  const [containsPreviewModifier, setContainsPreviewModifier] = useState("or");
  const [notContainsPreviewModifier, setNotContainsPreviewModifier] = useState("and");
  const [showAlert1, setShowAlert1] = useState(false);
  const [showAlert2, setShowAlert2] = useState(false);
  const [containsInput, setContainsInput] = useState("");
  const [notContainsInput, setNotContainsInput] = useState("");
  const [containsTerms, setContainsTerms] = useState([]);
  const [notContainsTerms, setNotContainsTerms] = useState([]);
  const addContains = (value) => {
    setContainsTerms((containsTerms) => [...containsTerms, value]);
    setContainsInput("");
  };
  const addNotContains = (value) => {
    setNotContainsTerms((notContainsTerms) => [...notContainsTerms, value]);
    setNotContainsInput("");
  };
  const addItem = (value, section) => {
    let tempValue = value.toLowerCase();
    let tempContainsTerms = containsTerms.map((el) => el.toLowerCase());
    let tempNotContainsTerms = notContainsTerms.map((el) => el.toLowerCase());
    value === "" && section === "contains"
      ? setShowAlert1(true)
      : value === "" && section === "notContains"
      ? setShowAlert2(true)
      : section === "contains" && tempContainsTerms.includes(tempValue)
      ? setShowAlert1(true)
      : section === "notContains" && tempNotContainsTerms.includes(tempValue)
      ? setShowAlert2(true)
      : section === "contains" && !tempContainsTerms.includes(tempValue)
      ? addContains(value)
      : section === "notContains" && tempNotContainsTerms.includes(tempValue)
      ? undefined
      : section === "notContains" && !tempNotContainsTerms.includes(tempValue)
      ? addNotContains(value)
      : undefined;
  };
  let names = [];
  campaignGroups.forEach((el, index) => {
    names.push(el.name);
  });
  const [campaignGroupsNames, setCampaignGroupsNames] = useState(names);
  const currentSection = `${props.platformType.toLowerCase()}_section`;
  const campaignGroupsOrder = jsDig([currentSection, "campaign_group_order"], props) ? jsDig([currentSection, "campaign_group_order"], props) : [];
  const defaultSectionOrder = campaignGroupsOrder.length > 0 ? campaignGroupsOrder.map((id) => id.toString()) : [];
  const [sectionOrder, setSectionOrder] = useState(defaultSectionOrder);

  const handleAddBox = (conversionActions, conversionActionsEnabled, customConversions, conversionObjective, tiktokConversionObjective) => {
    let newItemId = uuidv4();
    const containsWords = containsPreviewModifier == "and" ? { and: containsTerms, or: [] } : { and: [], or: containsTerms };
    const notContainsWords = notContainsPreviewModifier == "and" ? { and: notContainsTerms, or: [] } : { and: [], or: notContainsTerms };
    let newItem = {
      id: newItemId,
      name: campaignGroupsNames[campaignGroupsNames.length - 1],
      conditions: {
        contains: containsWords,
        not_contains: notContainsWords,
      }
    }
    if (props.platformType == "Social") {
      newItem.conversion_objective = conversionObjective;
      newItem.tiktok_conversion_objective = tiktokConversionObjective;
      newItem.custom_conversions = customConversions;
    } else {
      newItem.conversion_actions_enabled = conversionActionsEnabled;
      newItem.conversion_actions = conversionActions;
    }
    if (props.onboarding && props.setCampaignGroups) {
      // Update the state of Onboarding.jsx if rendered from there
      const newCampaignGroups = [...campaignGroups, newItem];
      let allCampaignGroups = {};
      Object.keys(props.allCampaignGroups).forEach((sectionName) => {
        allCampaignGroups[sectionName] = sectionName == platform ? newCampaignGroups : props.allCampaignGroups[sectionName];
      });
      props.setCampaignGroups({ ...allCampaignGroups });
    }

    setSectionOrder([...sectionOrder, `${newItem.id}`]);
    setCampaignGroups([...campaignGroups, newItem]);
  };
  const handleEditBox = (
    itemId,
    newName,
    term,
    contains,
    action,
    containsList,
    notContainsList,
    conversionEnabled,
    conversionActions,
    customConversions,
    conversionObjective,
    tiktokConversionObjective,
    groupContainsModifier,
    groupNotContainsModifier
  ) => {
    let newCampaignGroups = campaignGroups;
    let newContainsTerms = containsList;
    let newNotContainsTerms = notContainsList;
    if (contains == "contains") {
      if (action == "remove") newContainsTerms = newContainsTerms.filter((el) => el != term.toLowerCase());
      else if (action == "add") {
        if (!newContainsTerms.includes(term.toLowerCase())) {
          newContainsTerms.push(term.toLowerCase());
        }
      }
    } else if (contains == "notContains") {
      if (action == "remove") newNotContainsTerms = newNotContainsTerms.filter((el) => el != term.toLowerCase());
      else if (action == "add") newNotContainsTerms.push(term.toLowerCase());
    }
    const containsWords = groupContainsModifier && groupContainsModifier == "and" ? { and: newContainsTerms, or: [] } : { and: [], or: newContainsTerms };
    const notContainsWords = groupNotContainsModifier && groupNotContainsModifier == "and" ? { and: newNotContainsTerms, or: [] } : { and: [], or: newNotContainsTerms };
    const newItem = {
      id: itemId,
      name: newName,
      conditions: {
        contains: containsWords,
        not_contains: notContainsWords,
      }
    };
    if (props.platformType == "Social") {
      newItem.conversion_objective = conversionObjective;
      newItem.tiktok_conversion_objective = tiktokConversionObjective;
      newItem.custom_conversions = customConversions;
    } else {
      newItem.conversion_actions_enabled = conversionEnabled;
      newItem.conversion_actions = conversionActions;
    }

    const index = newCampaignGroups.findIndex((el) => el.id == itemId);
    newCampaignGroups[index] = newItem;
    setCampaignGroups([...newCampaignGroups]);
    if (props.onboarding && props.setCampaignGroups) {
      // Update the state of Onboarding.jsx if rendered from there
      let allCampaignGroups = {};
      Object.keys(props.allCampaignGroups).forEach((sectionName) => {
        allCampaignGroups[sectionName] = sectionName == platform ? newCampaignGroups : props.allCampaignGroups[sectionName];
      });
      props.setCampaignGroups(allCampaignGroups);
    }
  };

  const removeItem = (term, section) => {
    term = term.toLowerCase();
    section === "contains"
      ? setContainsTerms(containsTerms.filter((el) => el.toLowerCase() !== term))
      : setNotContainsTerms(notContainsTerms.filter((el) => el.toLowerCase() !== term));
  };

  const handleDeleteBox = (itemId) => {
    let deleteState = campaignGroups.filter((group) => group.id != itemId);
    setCampaignGroups([...deleteState]);
    setSectionOrder([...sectionOrder.filter((groupId) => groupId != itemId)]);
    if (props.onboarding && props.setCampaignGroups) {
      // Update the state of Onboarding.jsx if rendered from there
      let allCampaignGroups = {};
      Object.keys(props.allCampaignGroups).forEach((sectionName) => {
        allCampaignGroups[sectionName] = sectionName == platform ? deleteState : props.allCampaignGroups[sectionName];
      });

      props.setCampaignGroups(allCampaignGroups);
    }
  };
  
  // ======================ITEMS BETWEEN THESE LINES ARE FOR DRAG AND DROP======================

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;
    if (!destination) {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }

    // Since we added a second droppable column we can't just splice the draggableIndex into section order
    // We need to figure out what the index should be based on the column
    const getIndex = (index, col) => index * 2 + (col.includes("col-2") ? 1 : 0);
    let newOrder = [...sectionOrder];
    newOrder.splice(getIndex(source.index, source.droppableId), 1);
    newOrder.splice(getIndex(destination.index, destination.droppableId), 0, draggableId);
    setSectionOrder(newOrder);
  };
  
  return (
    <div className="top-div p-3">
      <Row className="py-5 px-3 px-md-5 d-flex justify-content-center collapse-padding-mobile">
        <Col xs={12}>
          {!props.onboarding && (
            <div className="">
              <p  className="text-info visby-bold f18">
                Campaign Groups:
              </p>
              <p className="py-1 nunito-regular f16">
                Here you can create new campaign groups, view and edit all of your existing campaign groups, and click and drag to reorder them.
                <b> Only the top three campaign groups will be displayed in the PPC Summary (indicated with a blue triangle in the bottom-right corner).</b>
              </p>
            </div>
          )}
          <ConfigureCampaignGroup
            {...props}
            handleAddBox={handleAddBox}
            setCampaignGroupsNames={setCampaignGroupsNames}
            campaignGroupsNames={campaignGroupsNames}
            addItem={addItem}
            removeItem={removeItem}
            addContains={addContains}
            addNotContains={addNotContains}
            containsInput={containsInput}
            notContainsInput={notContainsInput}
            setContainsInput={setContainsInput}
            setNotContainsInput={setNotContainsInput}
            containsTerms={containsTerms}
            setContainsTerms={setContainsTerms}
            notContainsTerms={notContainsTerms}
            setNotContainsTerms={setNotContainsTerms}
            containsPreviewModifier={containsPreviewModifier}
            notContainsPreviewModifier={notContainsPreviewModifier}
            setContainsPreviewModifier={setContainsPreviewModifier}
            setNotContainsPreviewModifier={setNotContainsPreviewModifier}
            showAlert1={showAlert1}
            showAlert2={showAlert2}
            setShowAlert1={setShowAlert1}
            setShowAlert2={setShowAlert2}
          />
        </Col>
        <Col xs={12}>
          {
            /* Moving the hidden inputs out of the drag and drop stuff to preserve campaign group order */
            sectionOrder.map((groupId, idx) => {
              const campaign = campaignGroups.find((group) => group.id == groupId);
              if (campaign) {
                return (
                  <React.Fragment key={idx}>
                    <input readOnly hidden name={`campaign_groups[${platform}][][name]`} value={campaign.name} />
                    {campaign.conditions.contains && (
                      <>
                        {Array.isArray(campaign.conditions.contains.and)
                          ? campaign.conditions.contains.and.map((words, i) => {
                              return <input key={i} readOnly hidden name={`campaign_groups[${platform}][][contains][and][]`} value={words} />;
                            })
                          : campaign.conditions.contains.and &&
                            campaign.conditions.contains.and.split(",").map((words, i) => {
                              return <input key={i} readOnly hidden name={`campaign_groups[${platform}][][contains][and][]`} value={words} />;
                            })}
                        {Array.isArray(campaign.conditions.contains.or)
                          ? campaign.conditions.contains.or.map((words, i) => {
                              return <input key={i} readOnly hidden name={`campaign_groups[${platform}][][contains][or][]`} value={words} />;
                            })
                          : campaign.conditions.contains.or &&
                            campaign.conditions.contains.or.split(",").map((words, i) => {
                              return <input key={i} readOnly hidden name={`campaign_groups[${platform}][][contains][or][]`} value={words} />;
                            })}
                      </>
                    )}
                    {campaign.conditions.not_contains && (
                      <>
                        {Array.isArray(campaign.conditions.not_contains.and)
                          ? campaign.conditions.not_contains.and.map((words, i) => {
                              return <input key={i} readOnly hidden name={`campaign_groups[${platform}][][not_contains][and][]`} value={words} />;
                            })
                          : campaign.conditions.not_contains.and &&
                            campaign.conditions.not_contains.and.split(",").map((words, i) => {
                              return <input key={i} readOnly hidden name={`campaign_groups[${platform}][][not_contains][and][]`} value={words} />;
                            })}
                        {Array.isArray(campaign.conditions.not_contains.or)
                          ? campaign.conditions.not_contains.or.map((words, i) => {
                              return <input key={i} readOnly hidden name={`campaign_groups[${platform}][][not_contains][or][]`} value={words} />;
                            })
                          : campaign.conditions.not_contains.or &&
                            campaign.conditions.not_contains.or.split(",").map((words, i) => {
                              return <input key={i} readOnly hidden name={`campaign_groups[${platform}][][not_contains][or][]`} value={words} />;
                            })}
                      </>
                    )}

                    {campaign.id && <input readOnly hidden name={`campaign_groups[${platform}][][id]`} value={campaign.id} />}
                    {props.platformType == "Social" ? (
                      <>
                        <input readOnly hidden name={`campaign_groups[${platform}][][conversion_objective]`} value={campaign.conversion_objective} />
                        {campaign.custom_conversions &&
                        campaign.custom_conversions.length > 0 &&
                        campaign.custom_conversions.map((conversion, index) => {
                          return (
                            <React.Fragment key={index}>
                              <input readOnly hidden name={`campaign_groups[${platform}][][custom_conversions][][id]`} value={conversion.id} />
                              <input readOnly hidden name={`campaign_groups[${platform}][][custom_conversions][][label]`} value={conversion.label} />
                            </React.Fragment>
                          );
                        })}
                        <input readOnly hidden name={`campaign_groups[${platform}][][tiktok_conversion_objective]`} value={campaign.tiktok_conversion_objective} />
                      </>
                    ) : (
                      <>
                        <input readOnly hidden name={`campaign_groups[${platform}][][conversion_actions_enabled]`} value={campaign.conversion_actions_enabled} />
                        {campaign.conversion_actions &&
                          campaign.conversion_actions.length > 0 &&
                          campaign.conversion_actions.map((conversion) => {
                            return (
                              <div key={conversion.id ? conversion.id : uuidv4()}>
                                <input readOnly hidden name={`campaign_groups[${platform}][][conversion_actions][][name]`} value={conversion.name} />
                                <input
                                  readOnly
                                  hidden
                                  name={`campaign_groups[${platform}][][conversion_actions][][conversion_id]`}
                                  value={conversion.conversion_id}
                                />
                                <input
                                  readOnly
                                  hidden
                                  name={`campaign_groups[${platform}][][conversion_actions][][conversion_type]`}
                                  value={conversion.conversion_type}
                                />
                                {conversion.id && (
                                  <input readOnly hidden name={`campaign_groups[${platform}][][conversion_actions][][id]`} value={conversion.id} />
                                )}
                              </div>
                            );
                          })}
                      </>
                    )}
                  </React.Fragment>
                );
              }
            })
          }

          <div className="d-flex campaign-groups-list">
            <DragDropContext onDragEnd={onDragEnd}>
              {[1, 2].map((col) => {
                return (
                  <React.Fragment key={col}>
                    <Droppable key={col} droppableId={`campaign-groups-droppable-col-${col}`}>
                      {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef} style={{ flexWrap: "wrap" }} className="campaignLayout">
                          {sectionOrder
                            .filter((groupId, idx) => {
                              if (col == 1 && idx % 2 == 0) {
                                return groupId;
                              }
                              if (col == 2 && idx % 2 != 0) {
                                return groupId;
                              }
                            })
                            .map((groupId, idx) => {
                              const campaign = campaignGroups.find((group) => group.id == groupId);
                              if (campaign) {
                                return (
                                  <div className="campaign-column" style={{ backgroundColor: "#EEEEEE" }} key={campaign.id}>
                                    <CampaignGroup
                                      platformType={props.platformType}
                                      key={campaign.id}
                                      index={idx}
                                      content={campaign}
                                      draggableId={`${campaign.id}`}
                                      item={campaign}
                                      {...props}
                                      handleEditBox={handleEditBox}
                                      handleDeleteBox={handleDeleteBox}
                                      containsInput={containsInput}
                                      notContainsInput={notContainsInput}
                                      setContainsInput={setContainsInput}
                                      setNotContainsInput={setNotContainsInput}
                                      containsTerms={containsTerms}
                                      setContainsTerms={setContainsTerms}
                                      notContainsTerms={notContainsTerms}
                                      setNotContainsTerms={setNotContainsTerms}
                                      containsPreviewModifier={containsPreviewModifier}
                                      notContainsPreviewModifier={notContainsPreviewModifier}
                                      setContainsPreviewModifier={setContainsPreviewModifier}
                                      setNotContainsPreviewModifier={setNotContainsPreviewModifier}
                                      addItem={addItem}
                                      removeItem={removeItem}
                                      blueTriangle={sectionOrder.slice(0, 3).includes(`${campaign.id}`)}
                                    />
                                  </div>
                                );
                              }
                            })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </React.Fragment>
                );
              })}
            </DragDropContext>
          </div>
        </Col>
      </Row>
    </div>
  );
}
